import { render, staticRenderFns } from "./carihesap.vue?vue&type=template&id=2b65d459&scoped=true"
import script from "./carihesap.vue?vue&type=script&lang=js"
export * from "./carihesap.vue?vue&type=script&lang=js"
import style0 from "./carihesap.vue?vue&type=style&index=0&id=2b65d459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65d459",
  null
  
)

export default component.exports